import { useTranslation } from 'react-i18next';

import Collapse from 'components/collapse/Collapse';
import { MESSAGES_SENT_TO_SERVICE_PROVIDERS_TEMPLATE_ROWS } from '../SystemTemplatesTab.constants';
import SystemTemplatesTable from './common/SystemTemplatesTable';
import useVisibleSystemTemplateRows from './common/useVisibleSystemTemplateRows';

const MessagesSentToServiceProvidersSection = () => {
  const { t } = useTranslation();
  const { rows, isLoading } = useVisibleSystemTemplateRows(
    MESSAGES_SENT_TO_SERVICE_PROVIDERS_TEMPLATE_ROWS,
  );

  return (
    <Collapse
      data-testid="messages-sent-to-service-providers"
      defaultExpanded
      label={t(
        'pageAutomations.systemTemplates.sections.messagesSentToServiceProviders',
      )}
      variant="card"
    >
      <SystemTemplatesTable
        data-testid="messages-sent-to-service-providers-table"
        data={rows}
        isLoading={isLoading}
      />
    </Collapse>
  );
};

export default MessagesSentToServiceProvidersSection;
